import { useContext } from 'react'
import { GlobalContext } from '@context/GlobalContext/index'

const useGlobalContext = () => useContext(GlobalContext)

export default useGlobalContext
